// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmPropertiesWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAccountViewZrmPropertiesWebApiHandler_added,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_added_Path,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_list,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_list_Path,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_options,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Path,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_units,
  RentalManagerAccountViewZrmPropertiesWebApiHandler_units_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewExpandedPropertyUnitsResponseDto,
  AccountViewPropertiesResponseDto,
  AccountViewPropertyAddedResponseDto,
  AccountViewPropertyOptionsResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AddedParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}
interface ListParams {
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  groupId: string;
  isArchiveView?: boolean;
}
interface UnitsParams {
  groupId: string;
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export type RentalManagerAccountViewZrmPropertiesWebApiHandler_added_Options = UseQueryOptions<
  AccountViewPropertyAddedResponseDto,
  unknown,
  AccountViewPropertyAddedResponseDto,
  readonly [string, AddedParams]
>;

const RentalManagerAccountViewZrmPropertiesWebApiHandler_added_GetKey = (getParams: AddedParams) =>
  [RentalManagerAccountViewZrmPropertiesWebApiHandler_added_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_added_queryOptions = (
  getParams: AddedParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertiesWebApiHandler_added_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertiesWebApiHandler_added(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the property summary and next actions for the property-added success screen
 */
export const useRentalManagerAccountViewZrmPropertiesWebApiHandler_added = (
  getParams: AddedParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertiesWebApiHandler_added_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertiesWebApiHandler_added_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertiesWebApiHandler_added.getKey =
  RentalManagerAccountViewZrmPropertiesWebApiHandler_added_GetKey;

export type RentalManagerAccountViewZrmPropertiesWebApiHandler_list_Options = UseQueryOptions<
  AccountViewPropertiesResponseDto,
  unknown,
  AccountViewPropertiesResponseDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZrmPropertiesWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZrmPropertiesWebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertiesWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertiesWebApiHandler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table properties view
 */
export const useRentalManagerAccountViewZrmPropertiesWebApiHandler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertiesWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertiesWebApiHandler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertiesWebApiHandler_list.getKey =
  RentalManagerAccountViewZrmPropertiesWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Options = UseQueryOptions<
  AccountViewPropertyOptionsResponseDto,
  unknown,
  AccountViewPropertyOptionsResponseDto,
  readonly [string, OptionsParams]
>;

const RentalManagerAccountViewZrmPropertiesWebApiHandler_options_GetKey = (getParams: OptionsParams) =>
  [RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_options_queryOptions = (
  getParams: OptionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertiesWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertiesWebApiHandler_options(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table row options for a property
 */
export const useRentalManagerAccountViewZrmPropertiesWebApiHandler_options = (
  getParams: OptionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertiesWebApiHandler_options_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertiesWebApiHandler_options.getKey =
  RentalManagerAccountViewZrmPropertiesWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZrmPropertiesWebApiHandler_units_Options = UseQueryOptions<
  AccountViewExpandedPropertyUnitsResponseDto,
  unknown,
  AccountViewExpandedPropertyUnitsResponseDto,
  readonly [string, UnitsParams]
>;

const RentalManagerAccountViewZrmPropertiesWebApiHandler_units_GetKey = (getParams: UnitsParams) =>
  [RentalManagerAccountViewZrmPropertiesWebApiHandler_units_Path, getParams] as const;

export const RentalManagerAccountViewZrmPropertiesWebApiHandler_units_queryOptions = (
  getParams: UnitsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmPropertiesWebApiHandler_units_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmPropertiesWebApiHandler_units(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user property table units for a property
 */
export const useRentalManagerAccountViewZrmPropertiesWebApiHandler_units = (
  getParams: UnitsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmPropertiesWebApiHandler_units_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmPropertiesWebApiHandler_units_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmPropertiesWebApiHandler_units.getKey =
  RentalManagerAccountViewZrmPropertiesWebApiHandler_units_GetKey;
